import { Component, OnInit, Inject } from '@angular/core';
import { UserProfileService } from '../services/userprofile.services';
import { IUserProfile } from './user-profile';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddUserService } from '../../services/adduser.services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/user/services/auth.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
  providers: [UserProfileService] 
})
export class UserProfileComponent implements OnInit {

  profiles: IUserProfile[];  
  selectedProfile: number; 
  showUserProfileDialog;
  message;
  selected;

  constructor(private userProfileService: UserProfileService,
    private addUserService: AddUserService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<UserProfileComponent>,
    private router: Router, 
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: string) {      
    this.message = data;
    this.userProfileService.getProfiles().subscribe(
      (res: any) => {
        this.profiles = res;  
        this.selected = this.profiles[0].id_profile;
        this.selectedProfile = this.profiles[0].id_profile;
    },
      (err: HttpErrorResponse) => {
        if(err.status == 401) {
          this.authService.logout();
          this.dialogRef.close();
          this.router.navigate(['/user/login']);
        } else {
            (err) => console.log("Error while get CDN user data: ", err)
          }          
        }
      )
   }

  ngOnInit(): void {
  }
  saveProfile(): void {
   if(this.message.action == "save") {
   //create new user
   const userData = {
    id_profile: this.selected.id_profile,
    email: this.message.email,
    firstName: this.message.firstName,
    lastName: this.message.lastName,
    isActive: "true"
  }

   this.addUserService.addUser(userData).subscribe(
      (res:any) => {
        if(res.responseStatus === 'Success'){
          this.dialogRef.close();
        } else if(res.responseStatus === 'Failed'){
          const errorMessage = res.responseMessage;
          this.openSnackBar(errorMessage);
        } else if (res.responseCode != null && res.responseCode.statusCode === 401) {
          this.authService.logout();
          this.dialogRef.close();
          this.router.navigate(['/user/login']);
        }
      },
      err => {
        console.log(err);
      }
    )
  } else if(this.message.action == "update") { 
     //update user
   const userData = {
    id_profile: this.selected.id_profile,
    email: this.message.email
  }
   this.addUserService.changeProfile(userData).subscribe(
      (res:any) => {
        if(res.responseStatus === 'Success'){
          this.dialogRef.close();
        } else if(res.responseStatus === 'Failed'){
          const errorMessage = res.responseMessage;
          this.openSnackBar(errorMessage);
        } else if (res.responseCode != null && res.responseCode.statusCode === 401) {
          this.authService.logout();
          this.router.navigate(['/user/login']);
        }
      },
      err => {
        console.log(err);
      }
    )
  }
  }

  openSnackBar(message: string) {
    this.snackBar.open(message, 'close', {
      duration: 10000,
      verticalPosition: 'top'
    });
  }

  cancel(): void {
    this.dialogRef.close({saveData:false});
   }
}
